export default {
  props: {
    alertId: {
      type   : String,
      default: ''
    }
  },
  computed: {
    id () {
      return this.alertId || this.$route.params.id
    }
  }
}
